/**
 * Imperative RMS fill for the transport Record button.
 * Vertical scaleY (bottom → top); rAF only — no React per frame.
 */
import { meterHeightFromRms } from "../../../../src/lib/audio";
import { createMeterClock, smoothMeterLevel } from "./meterSmooth";

let fillEl: HTMLElement | null = null;
let getLevel: (() => number) | null = null;
let shown = 0;
let rafId = 0;
const clock = createMeterClock();

export function setTransportRecordMeterHost(options: {
  fill: HTMLElement;
  getLevel: () => number;
} | null): void {
  if (!options) {
    stopPump();
    shown = 0;
    // Zero the fill before dropping the ref — otherwise the last RMS height sticks.
    apply();
    fillEl = null;
    getLevel = null;
    return;
  }
  fillEl = options.fill;
  getLevel = options.getLevel;
  clock.reset();
  startPump();
}

export function clearTransportRecordMeter(): void {
  setTransportRecordMeterHost(null);
}

function startPump(): void {
  if (rafId !== 0) {
    return;
  }
  const tick = () => {
    rafId = requestAnimationFrame(tick);
    paint();
  };
  rafId = requestAnimationFrame(tick);
}

function stopPump(): void {
  if (rafId === 0) {
    return;
  }
  cancelAnimationFrame(rafId);
  rafId = 0;
}

function apply(): void {
  if (fillEl) {
    fillEl.style.transform = `scaleY(${shown})`;
  }
}

function paint(): void {
  if (!getLevel || !fillEl) {
    return;
  }
  const dt = clock.dt();
  shown = smoothMeterLevel(shown, meterHeightFromRms(getLevel()), dt);
  apply();
}
